// eslint-disable-next-line no-unused-vars
import React, { memo } from "react";
import PropTypes from "prop-types";
import { SWISSBILLING_INVOICE_TYPES } from "app/constants";
import { FormattedMessage } from "react-intl";

const RadioPictoContent = ({ type }) => {
	let iconClass = "icon icon--email-grey";
	let messageId = "swissbilling.invoice.type.email";

	if (type === SWISSBILLING_INVOICE_TYPES.PAPER) {
		iconClass = "icon icon--mail";
		messageId = "swissbilling.invoice.type.paper";
	}

	return (
		<>
			<i className={iconClass} />
			<div className="picto-radio__label">
				<FormattedMessage id={messageId} />
			</div>
		</>
	);
};

RadioPictoContent.propTypes = {
	type: PropTypes.string,
};
export default memo(RadioPictoContent);
